var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "TableList",
        {
          staticStyle: { height: "400px" },
          attrs: {
            columns: _vm.tabPaneConfig[0].columns,
            tableData: _vm.tabPaneConfig[0].tableData,
            loading: _vm.tabPaneConfig[0].loading,
            scroll: { x: 2200 },
            pagination: _vm.tabPaneConfig[0].pagination,
          },
          on: { change: _vm.handleTableChange },
          scopedSlots: _vm._u([
            {
              key: "action",
              fn: function ({ record }) {
                return [
                  _c(
                    "div",
                    { staticClass: "action-detail" },
                    [
                      _c(
                        "span",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.editLedger(record)
                            },
                          },
                        },
                        [_vm._v("编辑")]
                      ),
                      _c("a-divider", { attrs: { type: "vertical" } }),
                      _c(
                        "span",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.vieLedger(record)
                            },
                          },
                        },
                        [_vm._v("查看")]
                      ),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "div",
            {
              staticClass: "query-area",
              attrs: { slot: "queryArea" },
              slot: "queryArea",
            },
            [
              _c(
                "div",
                [
                  _c("j-dict-select-tag", {
                    staticClass: "search-space",
                    attrs: {
                      placeholder: "请选择年级",
                      dictCode:
                        "school_grade,grade_name,id,0=delete_flag order by sort_order",
                      allowClear: "",
                    },
                    on: {
                      change: () =>
                        _vm.$set(_vm.queryParam, "classId", undefined),
                      input: () =>
                        _vm.$set(_vm.queryParam, "classId", undefined),
                      clear: () =>
                        _vm.$set(_vm.queryParam, "classId", undefined),
                    },
                    model: {
                      value: _vm.queryParam.gradeId,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryParam, "gradeId", $$v)
                      },
                      expression: "queryParam.gradeId",
                    },
                  }),
                  _c("j-dict-select-tag", {
                    staticClass: "search-space",
                    attrs: {
                      placeholder: "请选择班级",
                      dictCode:
                        "school_class,name,id,grade_id=" +
                        (!_vm.queryParam.gradeId ? -1 : _vm.queryParam.gradeId),
                      async: true,
                    },
                    model: {
                      value: _vm.queryParam.classId,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryParam, "classId", $$v)
                      },
                      expression: "queryParam.classId",
                    },
                  }),
                  _c("a-range-picker", {
                    staticClass: "search-space",
                    staticStyle: { width: "230px" },
                    on: {
                      change: (dates, dateString) =>
                        _vm.onRangeChange(dates, dateString),
                    },
                    model: {
                      value: _vm.dateRange,
                      callback: function ($$v) {
                        _vm.dateRange = $$v
                      },
                      expression: "dateRange",
                    },
                  }),
                  _c("a-input-search", {
                    staticClass: "search-space",
                    staticStyle: { width: "170px" },
                    attrs: { placeholder: "请输入学生名字" },
                    on: { change: _vm.searchName },
                    model: {
                      value: _vm.queryParam.studentName,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryParam, "studentName", $$v)
                      },
                      expression: "queryParam.studentName",
                    },
                  }),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.queryTable },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "a-button",
                    {
                      staticStyle: { "margin-right": "10px" },
                      attrs: {
                        type: "primary",
                        icon: "download",
                        loading: _vm.exportXlsLoading,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.handleExportXlsv2("学生辅导")
                        },
                      },
                    },
                    [_vm._v("\n          导出\n        ")]
                  ),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.addLedger },
                    },
                    [_vm._v("添加台账")]
                  ),
                ],
                1
              ),
            ]
          ),
        ]
      ),
      _c("AddLedgerModal", {
        ref: "addLedgerModalRef",
        on: { refreshData: _vm.loadData },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }